import { Typography } from '@mui/material';
import dayjs from 'dayjs';

import { DataPopperRow } from '../../../data-popper';
import { tokens } from '../../../../theme/generated/tokens';

type TooltipProps = {
  data: { timestamp: string | number };
  timezone: string;
  testId: string;
  hideTime?: boolean;
};

export const ChartTooltipTimestampHeader = (props: TooltipProps) => {
  const timestamp = props.data.timestamp;
  const day = dayjs(timestamp).tz(props.timezone).format('MMM DD');
  const time = dayjs(timestamp).tz(props.timezone).format('h:mm A');
  const color = tokens.theme.fg.structural.secondary;

  return (
    <DataPopperRow
      testId={props.testId}
      dividerBottom
      left={
        <Typography variant="L10M" color={color}>
          {day}
        </Typography>
      }
      right={
        !props.hideTime && (
          <Typography variant="L10M" color={color}>
            {time}
          </Typography>
        )
      }
    />
  );
};
